export default {
  Auth: {
    identityPoolId: 'eu-west-1:97a70168-ff42-45b0-ba88-e1ce07d858dd',
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_1V6UxjGze',
    userPoolWebClientId: '8mmds9nnsiitpu0qlf44b6iv5',
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  API: {
    aws_appsync_graphqlEndpoint: 'https://ztrkomlkwnajbetfmzqe3dwiwu.appsync-api.eu-west-1.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  },
  Storage: {
    AWSS3: {
      bucket: 'op-stage-cognito',
      region: 'eu-west-1',
    },
  },
}
